export default "__VITE_ASSET__BL1Ji7tE__"